"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");

var _Object$defineProperty = require("@babel/runtime-corejs2/core-js/object/define-property");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/objectWithoutProperties"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _react = _interopRequireDefault(require("react"));

var _StyledSvg = _styledComponents["default"].svg.withConfig({
  displayName: "UserCircle___StyledSvg",
  componentId: "gfvgs-0"
})(["color:", ";width:", ";height:", ";vertical-align:text-top;"], function (p) {
  return p._css;
}, function (p) {
  return p._css2;
}, function (p) {
  return p._css3;
});

function UserCircle(_ref) {
  var _ref$title = _ref.title,
      title = _ref$title === void 0 ? null : _ref$title,
      props = (0, _objectWithoutProperties2["default"])(_ref, ["title"]);
  return _react["default"].createElement(_StyledSvg, (0, _extends2["default"])({
    width: "1em",
    height: "1em",
    viewBox: "0 0 480 480",
    focusable: false,
    "data-wbi-icon": true
  }, props, {
    _css: props.color,
    _css2: props.size,
    _css3: props.size
  }), title ? _react["default"].createElement("title", null, title) : null, _react["default"].createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M240 30C123.542 30 30 123.542 30 240s93.542 210 210 210 210-93.542 210-210S356.458 30 240 30zm5.723 383.722c-72.542 1.904-131.723-34.36-154.64-80.18 13.362-11.458 43.904-21 70.64-32.458 32.458-13.362 40.096-17.18 40.096-17.18V253.36s-11.458-9.542-15.277-38.18c-7.639 1.903-15.278-11.459-15.278-17.181 0-5.723 1.904-24.82 9.542-22.903-1.903-13.361-3.82-24.82-3.82-32.458 1.904-24.82 26.723-49.639 63-49.639 36.278 0 61.098 24.82 63 49.639 0 5.722 0 19.097-1.902 32.458 9.542-1.903 9.542 17.18 9.542 22.903 0 7.639-7.64 21-15.278 17.18-3.82 28.64-15.277 38.181-15.277 38.181v30.542s11.458 5.723 43.903 19.097c26.722 11.458 53.458 22.903 66.82 32.458-5.723 11.458-49.64 80.18-145.098 78.278l.027-.014z"
  }));
}

var _default = UserCircle;
exports["default"] = _default;